export default __webpack_public_path__ + "static/media/Blade's Wristbands of Creeping Death.75eada52.jpg";